(() => {
  function init(scope = document) {
    const roots = scope.matches?.('[data-yb-ultra-release]') ? [scope] : [...scope.querySelectorAll('[data-yb-ultra-release]')];
    roots.forEach(root => {
      if (root.dataset.enhanced === 'true') return;
      const config = JSON.parse(root.querySelector('[data-ybu-config]').textContent);
      const one = selector => root.querySelector(selector);
      const all = selector => [...root.querySelectorAll(selector)];
      const label = key => config.labels[key] ?? key;
      let variant = config.variants.find(item => String(item.id) === String(config.selected_id)) ?? config.variants[0];
      if (!variant) return;
      let quantity = variant.quantity_rule?.min || 1;
      let soundView = 'U03';
      const addButton = one('#ybu-add');
      const productForm = one('[data-ybu-product-form]');
      const variantInput = one('[name="id"]');
      const quantityInput = one('[name="quantity"]');
      const busy = () => addButton.classList.contains('loading') || productForm.cartRecoveryPending;
      const galleryItems = () => config.gallery[variant.color] || config.gallery.black;
      const money = (cents, formatted) => {
        if (quantity === 1 && formatted) return formatted;
        return new Intl.NumberFormat(config.lang || document.documentElement.lang || 'en', {style: 'currency', currency: config.currency, currencyDisplay: 'narrowSymbol'}).format(Number(cents) * quantity / 100) + ' ' + config.currency;
      };
      function normalizeQuantity(value) {
        const rule = variant.quantity_rule || {};
        const min = Number(rule.min) || 1, step = Number(rule.increment) || 1;
        let next = min + Math.max(0, Math.round((Number(value) - min) / step) || 0) * step;
        if (rule.max !== null && rule.max !== undefined) next = Math.min(next, Number(rule.max));
        return Math.max(min, next);
      }
      function renderGallery() {
        const [id, title] = galleryItems()[0];
        const hero = one('#gallery-image');
        hero.src = config.media[id].src;
        hero.alt = `YEAHBOX Ultra · ${label(variant.color)} · ${label(title)}`;
      }
      function updateBusy() {
        const pending = busy();
        one('.ybu-express-checkout').hidden = pending || !variant.available;
        all('[data-color]').forEach(button => {button.disabled = pending || !config.variants.some(item => item.color === button.dataset.color);});
        quantityInput.disabled = pending;
        const min = Number(variant.quantity_rule?.min) || 1;
        one('#quantity-minus').disabled = pending || quantity <= min;
        const max = variant.quantity_rule?.max;
        one('#quantity-plus').disabled = pending || max !== null && max !== undefined && quantity >= Number(max);
      }
      function updatePurchase() {
        const name = label(variant.color);
        quantity = normalizeQuantity(quantity);
        quantityInput.value = String(quantity);
        quantityInput.min = String(variant.quantity_rule?.min || 1);
        quantityInput.step = String(variant.quantity_rule?.increment || 1);
        const max = variant.quantity_rule?.max;
        if (max !== null && max !== undefined) quantityInput.max = String(max); else quantityInput.removeAttribute('max');
        all('[data-color]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === variant.color)));
        one('#selected-color').textContent = label('selection') + name;
        one('#configuration-summary').textContent = 'Ultra · ' + name;
        one('#quantity-summary').textContent = String(quantity);
        one('#mobile-configuration').textContent = `${name} · ${quantity}`;
        one('#purchase-price').textContent = money(variant.price, variant.price_formatted);
        const compare = one('#ybu-compare-price');
        compare.hidden = !variant.compare_price || Number(variant.compare_price) <= Number(variant.price);
        compare.textContent = compare.hidden ? '' : money(variant.compare_price, variant.compare_formatted);
        one('#ybu-availability').textContent = label(variant.available ? 'available' : 'sold');
        one('[data-add-label]').textContent = label(variant.available ? 'add' : 'sold');
        addButton.disabled = !variant.available;
        one('.ybu-express-checkout').hidden = !variant.available;
        one('[data-ybu-announcement]').textContent = `${name} Ultra · ${money(variant.price, variant.price_formatted)}`;
        updateBusy();
      }
      function setVariant(id, updateUrl = true, notify = true) {
        if (busy()) {variantInput.value = String(variant.id); return;}
        const next = config.variants.find(item => String(item.id) === String(id));
        if (!next) return;
        const changed = String(variant.id) !== String(next.id);
        variant = next;
        root.dataset.selectedVariant = String(variant.id);
        variantInput.value = String(variant.id);
        productForm.error = false;
        productForm.handleErrorMessage?.();
        addButton.removeAttribute('aria-disabled');
        updatePurchase();
        renderGallery();
        if (notify && changed) variantInput.dispatchEvent(new Event('change', {bubbles: true}));
        if (updateUrl) {const url = new URL(location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState({}, '', url);}
      }
      function setQuantity(value) {
        if (busy()) {quantityInput.value = String(quantity); return;}
        quantity = normalizeQuantity(value);
        updatePurchase();
        quantityInput.dispatchEvent(new Event('input', {bubbles: true}));
      }
      function sceneStep(direction) {
        const track = one('#scene-track'), cards = [...track.children];
        if (!cards.length) return;
        const origin = cards[0].offsetLeft, start = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const positions = cards.map(card => Math.min(max, card.offsetLeft - origin + start));
        let nearest = 0;
        positions.forEach((position, index) => {if (Math.abs(position - track.scrollLeft) < Math.abs(positions[nearest] - track.scrollLeft)) nearest = index;});
        const target = Math.max(0, Math.min(cards.length - 1, nearest + direction));
        track.scrollTo({left: positions[target], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      function updateSceneArrows() {
        const track = one('#scene-track'), start = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        all('.scene-prev').forEach(button => {button.disabled = track.scrollLeft <= start + 5;});
        all('.scene-next').forEach(button => {button.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 5;});
      }
      root.addEventListener('click', event => {
        const color = event.target.closest('[data-color]');
        if (color && !color.disabled) {const next = config.variants.find(item => item.color === color.dataset.color); if (next) setVariant(next.id); return;}
        const sound = event.target.closest('[data-sound]');
        if (sound) {soundView = sound.dataset.sound; one('#sound-image').src = config.media[soundView].src; one('#sound-image').alt = config.media[soundView].label; all('[data-sound]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sound === soundView))); return;}
        const anchor = event.target.closest('a[href^="#"]');
        if (anchor) {const target = one(anchor.getAttribute('href')); if (target) {event.preventDefault(); target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'}); const url = new URL(location.href); url.hash = anchor.getAttribute('href'); history.replaceState({}, '', url);}}
      });
      variantInput.addEventListener('change', event => setVariant(event.target.value, true, false));
      quantityInput.addEventListener('change', event => setQuantity(event.target.value));
      one('#quantity-minus').addEventListener('click', () => setQuantity(quantity - (Number(variant.quantity_rule?.increment) || 1)));
      one('#quantity-plus').addEventListener('click', () => setQuantity(quantity + (Number(variant.quantity_rule?.increment) || 1)));
      all('.scene-prev').forEach(button => button.addEventListener('click', () => sceneStep(-1)));
      all('.scene-next').forEach(button => button.addEventListener('click', () => sceneStep(1)));
      one('#scene-track').addEventListener('scroll', updateSceneArrows, {passive:true});
      one('#scene-track').addEventListener('keydown', event => {if (event.target === one('#scene-track') && ['ArrowLeft','ArrowRight'].includes(event.key)) {event.preventDefault(); sceneStep(event.key === 'ArrowLeft' ? -1 : 1);}});
      function layout() {
        const header = document.querySelector('.section-header');
        root.style.setProperty('--header-offset', Math.max(0, Math.min(160, header?.getBoundingClientRect().bottom || 0)) + 'px');
        updateSceneArrows();
      }
      window.addEventListener('resize', layout, {passive:true});
      window.addEventListener('scroll', layout, {passive:true});
      new MutationObserver(updateBusy).observe(addButton, {attributes:true, attributeFilter:['class','aria-disabled','disabled']});
      root.dataset.enhanced = 'true';
      setVariant(variant.id, false, false);
      layout();
      window.Shopify?.PaymentButton?.init?.();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
